import { isEmpty } from 'lodash';

import { uploadMusicTypes } from '@/types';

export const validateSongDetails = (data: uploadMusicTypes.UploadMusic) => {
  const err = {
    title: isEmpty(data.title) ? 'Title is required' : '',
    artist_name: isEmpty(data.artist_name) ? 'Artist name is required' : '',
    genre: isEmpty(data.genre.label) ? 'Song Genre is required' : '',
    thumbnail_image: !data.thumbnail_image ? 'Thumbnail image is required' : '',
    media: !data.media ? 'Audio file is required' : '',
    duration: data.duration <= 0 ? 'Invalid audio duration' : '',
  };
  return err;
};

export const getAudioDuration = (file: File): Promise<number> =>
  new Promise((resolve, reject) => {
    const audio = new Audio();
    audio.src = URL.createObjectURL(file);
    audio.preload = 'metadata';
    const handleLoaded = () => {
      const dur = audio.duration;
      URL.revokeObjectURL(audio.src);
      audio.removeEventListener('loadedmetadata', handleLoaded);
      audio.removeEventListener('error', handleError);
      resolve(dur);
    };
    const handleError = () => {
      URL.revokeObjectURL(audio.src);
      audio.removeEventListener('loadedmetadata', handleLoaded);
      audio.removeEventListener('error', handleError);
      reject(new Error('Failed to load audio metadata'));
    };
    audio.addEventListener('loadedmetadata', handleLoaded);
    audio.addEventListener('error', handleError);
  });


export const buildGetUrlsPayload = (formvalues: any, multipleOwners: boolean) => {
  const base = {
    title: formvalues.title,
    genre: formvalues.genre.value,
    artist_name: formvalues.artist_name,
    duration: formvalues.duration,
    description: formvalues.description || '',
    second_genre: formvalues.second_genre ? formvalues.second_genre.value : '',
    crew_credits: formvalues.crew_credits || '',
    multipleOwners,
    files: {
      thumbnail: formvalues.thumbnail_image
        ? {
            filename: formvalues.thumbnail_image.name,
            mimetype: formvalues.thumbnail_image.type,
          }
        : undefined,
      audio: formvalues.media
        ? {
            filename: formvalues.media.name,
            mimetype: formvalues.media.type,
          }
        : undefined,
    },
  };
  if (multipleOwners) {
    const docs = formvalues.collectionRights
      .map((cr: any) =>
        cr.document
          ? {
              filename: cr.document.name,
              mimetype: cr.document.type,
            }
          : null,
      )
      .filter((d: any) => d);
    return {
      ...base,
      collectionRightsCount: formvalues.collectionRights.length,
      files: {
        ...base.files,
        documents: docs,
      },
    };
  }
  return base;
};

export const buildSongUploadPayload = (
  formvalues: any,
  song_id: string,
  keys: any,
  multipleOwners: boolean,
) => {
  const base = {
    song_id,
    title: formvalues.title,
    genre: formvalues.genre.value,
    artist_name: formvalues.artist_name,
    duration: formvalues.duration,
    description: formvalues.description || '',
    second_genre: formvalues.second_genre ? formvalues.second_genre.value : '',
    crew_credits: formvalues.crew_credits || '',
    multipleOwners,
    thumbnail_key: keys.thumbnail,
    audio_key: keys.audio,
  };
  if (multipleOwners) {
    return {
      ...base,
      collectionRights: formvalues.collectionRights.map((cr: any) => ({
        role: cr.role,
        firstName: cr.firstName,
        lastName: cr.lastName,
      })),
      document_keys: keys.documents,
    };
  }
  return base;
};
